import React, { Component } from 'react';
import { Modal, Input, Select, Radio, Button, InputNumber, Checkbox, message, Icon } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Option = Select.Option;
const InputGroup = Input.Group;
const CheckboxGroup = Checkbox.Group;

class MoreConditionUser extends Component {
    state = {
        visible: false,
        role: '',
        searchParams: {
            experienceSymbol: 'GreatThan',
            fteSymbol: 'GreatThan',
        },
        employeeList: [],
        addList: [],
        loading: false,
    }

    show = role => {
        this.setState({
            role,
            visible: true,
            searchParams: {
                experienceSymbol: 'GreatThan',
                fteSymbol: 'GreatThan',
            },
            employeeList: [],
            addList: [],
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    handleSearch = () => {
        const { searchParams } = this.state;
        this.setState({
            addList: [],
            loading: true,
        });
        const options = {
            url: API_URL.user.queryUserByExpandCond,
            data: searchParams,
            dataType: 'json',
            doneResult: res => {
                const employeeList = [];
                if (res.datas) {
                    res.datas.forEach(item => {
                        const label = `${item.userCompellation}[${item.employeeCode}]`;
                        employeeList.push({
                            label,
                            value: item.userId,
                            text: label,
                        });
                    });
                }
                if (!employeeList.length) {
                    message.warning('暂未检索到人员！');
                }
                this.setState({
                    employeeList,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleCheckboxChange = (checkedValues, e) => {
        const { employeeList } = this.state;
        const addList = [];
        if (checkedValues) {
            checkedValues.forEach(value => {
                const obj = employeeList.find(employee => employee.value == value);
                obj && addList.push(obj);
            });
        }
        this.setState({ addList });
    }

    handleSubmit = () => {
        const { addList } = this.state;
        this.props.addFromCondition(addList);
        this.hide();
    }

    render() {
        const { visible, searchParams, employeeList, loading } = this.state;
        const { experienceSymbol, experience, fteSymbol, fte } = searchParams;
        return (
            <Modal
                title="更多检索条件"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="560px"
                footer={[
                    <Button type="primary" onClick={this.handleSubmit}>
                        添加
                    </Button>
                ]}
            >
                <div className="condition">
                    <div className="con-detail">
                        <div className="con-row">
                            <label className="row-label">临床研究经验：</label>
                            <InputGroup compact>
                                <Select value={experienceSymbol} style={{ width: 40 }} onChange={value => this.handleSelectChange(value, 'experienceSymbol')}>
                                    <Option value="GreatThan">&gt;</Option>
                                    <Option value="NotLess">&ge;</Option>
                                    <Option value="LessThan">&lt;</Option>
                                    <Option value="NotGreat">&le;</Option>
                                    <Option value="Equals">=</Option>
                                </Select>
                                <InputNumber value={experience} formatter={value => value !== value ? '' : value} onChange={value => this.handleSelectChange(value, 'experience')} style={{ width: '60px' }} />
                                &nbsp;月
                        </InputGroup>

                        </div>
                        <div className="con-row">
                            <label className="row-label">上月工作量：</label>
                            <InputGroup compact>
                                <Select value={fteSymbol} style={{ width: 40 }} onChange={value => this.handleSelectChange(value, 'fteSymbol')}>
                                    <Option value="GreatThan">&gt;</Option>
                                    <Option value="NotLess">&ge;</Option>
                                    <Option value="LessThan">&lt;</Option>
                                    <Option value="NotGreat">&le;</Option>
                                    <Option value="Equals">=</Option>
                                </Select>
                                <InputNumber value={fte} formatter={value => value !== value ? '' : value} onChange={value => this.handleSelectChange(value, 'fte')} style={{ width: '60px' }} />
                                &nbsp;FTE
                        </InputGroup>
                        </div>
                    </div>
                    <div className="con-search">
                        <Button type="primary" loading={loading} onClick={this.handleSearch}>检索</Button>
                    </div>
                    <div className="clear"></div>
                </div>
                <div className="con-options">
                    <label className="row-label">
                        请选择：
                    </label>
                    <div className="clear"></div>
                    <div className="option-list">
                        <CheckboxGroup options={employeeList} onChange={this.handleCheckboxChange} />
                    </div>
                </div>
            </Modal>
        )
    }
}

class AddProjectRole extends Component {
    state = {
        user: {}
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible && !this.props.visible) {
            this.setState({ user: {} });
        }
    }

    addFromCondition = (role, addList = []) => {
        if (addList.length > 0) {
            const { role, data } = this.props;
            addList.forEach(item => {
                if (!data.some(user => user.value == item.value)) {
                    if (role === 'pm' && data.length === 0) {
                        item.isMain = 1;
                    }
                    data.push(item);
                }
            });
            this.props.onChange(data);
        }
    }

    handleDelete = (value) => {
        const { role, data } = this.props;
        const idx = data.findIndex(user => user.value == value);
        if (role === 'pm' && data[idx].isMain && data.length > 1) {
            message.warning('该人员为大项目经理不可删除，请先移除大项目经理');
            return;
        } else if (role === 'bd' && data.length === 1) {
            message.warning('BD为必填字段，需至少保留一个BD');
            return;
        }
        data.splice(idx, 1);
        this.props.onChange(data);
    }

    handleAdd = () => {
        const { role, data } = this.props; 
        const { user } = this.state;
        if (!user.value) return;
        if (role === 'pm' && data.length === 0) {
            user.isMain = 1;
        }
        data.push(user);
        this.setState({ user: {} }, () => {
            this.props.onChange(data);
        });
    }

    setMain = (e, params) => {
        const { value, isMain } = params;
        if (isMain) {
            return;
        } else {
            const { data } = this.props;
            data.forEach(item => {
                if (item.value == value) {
                    item.isMain = 1;
                } else {
                    item.isMain = 0;
                }
            });
            this.props.onChange(data);
        }
    }

    handleChange = (value, key) => {
        this.setState({ [key]: value });
    }

    moreUser = () => {
        this.moreUserRef.show('');
    }

    render() {
        const { role, data } = this.props;
        const { user } = this.state;
        return (
            <div>
                <div style={{ position: 'relative' }}>
                    <InputGroup compact>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 162 }}
                            placeholder="输入姓名/工号检索"
                            value={user.text}
                            params={{ limit: 20, dimissionStatus: 'WORKING' }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode',show:"user" }}
                            onChange={option => this.handleChange(option, 'user')}
                        />
                        <Button onClick={this.moreUser}>更多</Button>
                    </InputGroup>
                    <Icon
                        style={{
                            position: 'absolute',
                            top: 10,
                            left: 235,
                            fontSize: '16px',
                            color: '#108ee9',
                            cursor: 'pointer',
                        }}
                        type="plus-circle-o"
                        onClick={this.handleAdd}
                    />
                </div>
                <div>
                    {
                        (data || []).map(i => 
                            <div style={{position: 'relative'}} key={i.value}>
                                {i.text}
                                <Icon
                                    type="close-circle-o"
                                    onClick={() => this.handleDelete(i.value)}
                                    style={{position: 'absolute', top: 10, left: 110, color: '#F00', fontSize: 16, verticalAlign: 'middle', cursor: 'pointer'}}
                                />
                                { (role === 'pm' && data.length > 1) && <Radio checked={i.isMain === 1} style={{position: 'absolute', left: 140}} onChange={e => this.setMain(e, i)}>大项目经理</Radio> }
                            </div>
                        )
                    }
                </div>
                <MoreConditionUser ref={el => this.moreUserRef = el} addFromCondition={this.addFromCondition} />
            </div>
        );
    }
}

export default AddProjectRole;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/AddProjectRole.js